export enum UserType {
  'practitioner',
  'technician'
}

export enum PreferredView {
  Overview = 'overview',
  Report = 'report',
  Graphs = 'graphs'
}
